import { render, staticRenderFns } from "./EmailNew.vue?vue&type=template&id=d76728a0&"
import script from "./EmailNew.vue?vue&type=script&lang=js&"
export * from "./EmailNew.vue?vue&type=script&lang=js&"
import style0 from "./EmailNew.vue?vue&type=style&index=0&id=d76728a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports